import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';
import { LoaderService } from "src/app/Services/loader.service";

@Component({
  selector: 'app-no-show-report',
  templateUrl: './no-show-report.component.html',
  styleUrls: ['./no-show-report.component.css']
})
export class NoShowReportComponent implements OnInit {

  constructor(
    private dateAdapter: DateAdapter<Date>,
    public storage: StorageService,
    public api: ApiService,
    public com: CommonServices,    
    private loader: LoaderService,
    public excel: ExcelExportService
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  }

  ngOnInit(): void {
    this.filterFormsLoad();
    this.headCountAPI(({
      tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    }))
    this.getListShift();
  }

  public filterFormGrp: FormGroup;
  public tableHeaders: any = ['#', 'Reg no','Shift time', 'Employee ID', 'Employee name', 'Transit mode'];
  public tableData: any = [];
  public matFormSize: string = '13px';
  public vehWiseObj: any = [];
  public getTranMode: any = '';
  public noShowWiseArr: any = [];
  public noDataFoundEnable: boolean = false;
  public filteredData:any=[];
  public resData:any= [];
  public shiftListArr: any = [];
  public getBranchListArr:any=[];
  public gettime:any='';
  public convertedTime:any='';
  public responseData:any = [];
  public currentYear = new Date().getFullYear();
  public minDate = new Date(this.currentYear - 1, 0, 1);
  public maxDate = new Date(this.currentYear, 11, 31);
  // Excel Variabels
  public excelData: any = [];

  filterFormsLoad() {
    this.filterFormGrp = new FormGroup({
      tripDate: new FormControl(new Date),
      transitMode: new FormControl(''),
      shiftTimeStr: new FormControl(''),
    })
  }

  fieldChange(e: any, fieldType) {
    this.convertedTime= ''
    let value = e.value;
    if (fieldType == 'transitMode') {
      this.getTranMode = value;
    }
    if (fieldType == 'shiftTimeStr') {
      this.gettime = value;
      this.convertTime12to24(this.gettime)
    }
  }

  convertTime12to24(time12h){
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
      if (hours === "12") {
          hours = "00";
      }
      if (modifier === "PM") {
          hours = parseInt(hours, 10) + 12;
      }
      this.convertedTime = `${hours}:${minutes}`
      return this.convertedTime;
  }

  headCountAPI(obj) {
    this.tableData = [];
    this.shiftListArr = [];
    this.api.getHeadCountReports(obj).then((res: any) => {
      if (res && res['status'] && res['status'] == 'success') {
        if (res && res['data'] && res['data'].length > 0) {
          this.resData = res['data'][0];
          if(Object.keys(this.resData).length > 0){
            this.loader.hide()
          }else{
            this.loader.show()
          }
          if (this.tableData.length <= 0) {
            this.noDataFoundEnable = true
          }
          this.changeTheObjToVehWise();
          this.getShitTimeOnly(this.filteredData);
        } else {
          this.tableData = [];
          this.noShowWiseArr = [];
          this.noDataFoundEnable = true;
        }
      } else {
        this.tableData = [];
        this.noShowWiseArr = [];
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  getListShift() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      if (res && res.status && res.status == 'success') {
        if (res && res['data'] && res['data'].length > 0) {
          let resData = res['data'];
          for(let b=0;b<resData.length ;b++){
            let obj={}
            obj['endTime']=resData[b]['endTime'];
            obj['startTime']=resData[b]['startTime'];
            obj['shiftName']=resData[b]['shiftName'];
            this.getBranchListArr.push(obj)
          }
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getShitTimeOnly(obj: any) {
    let shiftArr = [];
    obj.map((shift: any) => {
      shiftArr.push(shift['shiftTimeStr'])
    })
    if(shiftArr.length > 0){
      this.shiftListArr = this.removeDuplicates(shiftArr);
    }
  }
  removeDuplicates(arr) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }

  resetFilterForm(){
    this.gettime = '';
    this.getTranMode = '';
    this.filterFormGrp.patchValue({
      tripDate:new Date(),
      transitMode: '',
      shiftTimeStr: ''
    })  
    this.headCountAPI({
      tripDate: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    }) 
    this.fieldChange({'value':''},'transitMode')
  }

  onSubmit() {
    let obj = {}
    if (obj['tripDate'] != '') obj['tripDate'] = new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    if (this.filterFormGrp.valid) {
      this.headCountAPI(obj)
    }
  }

  changeTheObjToVehWise() {
    this.filteredData = [];
    let obj = this.resData;
    let transitModes = Object.keys(obj)
    if (transitModes.length > 0) {
      for (let i = 0; i < transitModes.length; i++) {

        let shiftTimes = Object.keys(obj[transitModes[i]])
        for (let j = 0; j < shiftTimes.length; j++) {

          let vehRegNumbers = Object.keys(obj[transitModes[i]][shiftTimes[j]])
          for (let k = 0; k < vehRegNumbers.length; k++) {
            let lastKeys = obj[transitModes[i]][shiftTimes[j]][vehRegNumbers[k]]
          
            if (lastKeys['noShow'] && lastKeys['noShow'].length > 0) {
              for(let l=0;l < lastKeys['noShow'].length;l++){
                let empData = lastKeys['noShow'][l]
          
                let finalObj = {}

                finalObj['vehRegNo'] = vehRegNumbers[k];
                finalObj['transitMode'] = transitModes[i];
                finalObj['shiftTimeStr'] = shiftTimes[j];
                finalObj['name'] = empData['name'];
                finalObj['empRefID'] = empData['empRefID']
                this.tableData.push(finalObj)
                this.filteredData.push(finalObj)
              }
            }
          }
        }
        this.responseData = this.filteredData;
      }
      this.responseData = this.filteredData;
    }
      // Filter Functionality Area
      if(this.gettime && this.filterFormGrp.value.transitMode == ''){
        let arr =  this.gettime.split('-') //['4:00 PM','10:00 AM']
        if(arr.length>0){
          arr = arr.map((item:any)=>{
            item = this.convertTime12to24(item);
            return item;
          })
       
          let obj ={}
            obj['Pickup'] = arr[0]
            obj['Drop'] = arr[1]
      
          let finalArr =[];
          for(let i=0;i<this.filteredData.length ;i++){
            let time = this.filteredData[i];
            Object.keys(obj).map((modes:any)=>{
              if(modes == time['transitMode']){
                if(time && time['shiftTimeStr'] && time['transitMode']){
                  if(obj[modes] == time['shiftTimeStr']){
                    finalArr.push(time);
                  }
                }
              }
            })
          }
          this.filteredData = finalArr;
        }
      }
      if (this.gettime != '' && (this.filterFormGrp.value.transitMode == 'Pickup' || this.filterFormGrp.value.transitMode == 'Drop')) {
        this.filteredData = this.filteredData.filter(e => e['shiftTimeStr'] == this.convertedTime)
      }
      if (this.getTranMode != '') {
        this.filteredData = this.filteredData.filter(e => e['transitMode'] == this.getTranMode)
      }
  }

  // Excel download 

  async exportToExcel() {
    this.excelData = {};
    let data = [];
    for (let i = 0; i < this.filteredData.length; i++) {
      let item = this.filteredData[i];
      this.getTranMode = this.getTranMode != '' ? this.getTranMode : 'Both';
      try {
        let res = {
          value: [
            i + 1,
            item.shiftTimeStr ? item.shiftTimeStr : '---',
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.name ? String(item.name).charAt(0).toUpperCase() + String(item.name).slice(1).toLowerCase() : '---',
            item.transitMode ? this.com.convertTitleCase(item.transitMode) : '---',
          ],
          border: { right: { style: 'thin' }, bottom: { style: 'thin' } },
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = 'E';
      let customizedData = [];
      let titleRow = {
        value: ['No Show Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);

      rowCount = rowCount + 2;

      let subtitleRow = {
        value: [
          "Trip Date          : " + this.com.timestampToDate(new Date(this.filterFormGrp.value.tripDate).getTime(), 'DMY') + "\n" +
          "Transit Mode       : " + this.getTranMode + ""
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Shift time', 'Employee ID', 'Employee name', 'Transit mode'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = 'No Show Report';
      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 15 }, { colNo: 3, width: 25 }, { colNo: 4, width: 25 }, { colNo: 5, width: 15 }, { colNo: 6, width: 20 }, { colNo: 7, width: 25 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }]
        }
      };// excelInfo;
      this.downloadExlReport();
    }
  }
  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'No Show Report_' + " "+this.com.timestampToDate(new Date().getTime(), 'DMY') + ' '  + '.xlsx');
  }
}
